<template>
  <div class="profile">
    <header>
      <div><avatar :user="user" /></div>
      <h1>{{user.name}}</h1>
    </header>
    <h2>Public Albums</h2>
    <albums-wall :albums="albums" :pages="pages" />
  </div>
</template>

<script>
import AlbumsWall from './AlbumsWall'
import Avatar from './Avatar'
export default {
  props: ['user', 'albums', 'pages'],
  components: {
    AlbumsWall,
    Avatar,
  },
}
</script>

<style lang="stylus" scoped>
header
  display flex
  align-items center
  h1
    margin-left 10px
</style>
